import api from './client';

// Travel schedule API
export const travelScheduleAPI = {
  // Create travel schedule
  create: (data: {
    destination: string;
    startDate: string;
    endDate: string;
    tripType?: string;
    visibility?: string;
    availability?: string;
    notes?: string;
    userId?: number | string;
    allow_overlap?: boolean;
  }) => api.post('/travel-schedules', {
    destination: data.destination,
    start_date: data.startDate,
    end_date: data.endDate,
    trip_type: data.tripType,
    visibility: data.visibility,
    availability: data.availability,
    notes: data.notes,
    user_id: data.userId,
    allow_overlap: data.allow_overlap,
  }),

  // Get all travel schedules
  getAll: (params?: {
    userId?: number;
    startAfter?: string;
    endBefore?: string;
    includePast?: boolean;
  }) => api.get('/travel-schedules', {
    params: params ? {
      user_id: params.userId,
      start_after: params.startAfter,
      end_before: params.endBefore,
      include_past: params.includePast,
    } : undefined,
  }),

  // Get single travel schedule
  get: (id: number) => api.get(`/travel-schedules/${id}`),

  // Update travel schedule
  update: (id: number, data: {
    destination?: string;
    startDate?: string;
    endDate?: string;
    tripType?: string;
    visibility?: string;
    availability?: string;
    notes?: string;
    allow_overlap?: boolean;
  }) => api.put(`/travel-schedules/${id}`, {
    destination: data.destination,
    start_date: data.startDate,
    end_date: data.endDate,
    trip_type: data.tripType,
    visibility: data.visibility,
    availability: data.availability,
    notes: data.notes,
    allow_overlap: data.allow_overlap,
  }),

  // Delete travel schedule
  delete: (id: number) => api.delete(`/travel-schedules/${id}`),

  // Travel inventory
  addInventory: (scheduleId: number, inventoryItemId: number) =>
    api.post(`/travel-schedules/${scheduleId}/inventory`, { inventory_item_id: inventoryItemId }),

  getInventory: (scheduleId: number) =>
    api.get(`/travel-schedules/${scheduleId}/inventory`),

  markPacked: (scheduleId: number, itemId: number) =>
    api.put(`/travel-schedules/${scheduleId}/inventory/${itemId}/packed`),

  markUnpacked: (scheduleId: number, itemId: number) =>
    api.put(`/travel-schedules/${scheduleId}/inventory/${itemId}/unpacked`),

  removeInventory: (scheduleId: number, itemId: number) =>
    api.delete(`/travel-schedules/${scheduleId}/inventory/${itemId}`),

  // Check for travel schedule conflicts for a user within a date range
  checkConflicts: (userId: string, startDate: string, endDate: string) =>
    api.get('/travel-schedules/check-conflicts', {
      params: { userId, startDate, endDate }
    }),
};
